export var BenefitType;
(function (BenefitType) {
    BenefitType[BenefitType["AMOUNT_DISCOUNT"] = 1] = "AMOUNT_DISCOUNT";
    BenefitType[BenefitType["PERCENT_DISCOUNT"] = 2] = "PERCENT_DISCOUNT";
    BenefitType[BenefitType["TIME"] = 3] = "TIME";
    BenefitType[BenefitType["USAGES"] = 4] = "USAGES";
    BenefitType[BenefitType["FIXED_COST"] = 5] = "FIXED_COST";
})(BenefitType || (BenefitType = {}));
export var DisplayBenefitType;
(function (DisplayBenefitType) {
    DisplayBenefitType["AMOUNT_DISCOUNT"] = "AMOUNT_DISCOUNT";
    DisplayBenefitType["PERCENT_DISCOUNT"] = "PERCENT_DISCOUNT";
    DisplayBenefitType["TIME"] = "TIME";
    DisplayBenefitType["USAGES"] = "USAGES";
    DisplayBenefitType["FIXED_COST"] = "FIXED_COST";
})(DisplayBenefitType || (DisplayBenefitType = {}));
export var BenefitTypeLabel;
(function (BenefitTypeLabel) {
    BenefitTypeLabel["AMOUNT_DISCOUNT"] = "Wysoko\u015B\u0107 rabatu (w PLN) *";
    BenefitTypeLabel["PERCENT_DISCOUNT"] = "Wysoko\u015B\u0107 rabatu (%) *";
    BenefitTypeLabel["TIME"] = "Liczba minut *";
    BenefitTypeLabel["USAGES"] = "Liczba wej\u015B\u0107 *";
    BenefitTypeLabel["FIXED_COST"] = "Koszt us\u0142ugi (w PLN) *";
})(BenefitTypeLabel || (BenefitTypeLabel = {}));
export var BenefitTypeUnit;
(function (BenefitTypeUnit) {
    BenefitTypeUnit["AMOUNT_DISCOUNT"] = "z\u0142";
    BenefitTypeUnit["PERCENT_DISCOUNT"] = "%";
    BenefitTypeUnit["TIME"] = "min";
    BenefitTypeUnit["USAGES"] = "";
    BenefitTypeUnit["FIXED_COST"] = "z\u0142";
})(BenefitTypeUnit || (BenefitTypeUnit = {}));
export const BenefitTypeIconMobile = {
    [BenefitType.AMOUNT_DISCOUNT]: '\uf51e',
    [BenefitType.PERCENT_DISCOUNT]: '\uf541',
    [BenefitType.TIME]: '\uf2f2',
    [BenefitType.USAGES]: '\uf3ff',
    [BenefitType.FIXED_COST]: '\uf51e'
};
/**
 * @deprecated
 */
export const BenefitTypeTranslation = {
    [BenefitType.AMOUNT_DISCOUNT]: 'Zniżka kwotowa',
    [BenefitType.PERCENT_DISCOUNT]: 'Zniżka procentowa',
    [BenefitType.TIME]: 'Karnety czasowe',
    [BenefitType.USAGES]: 'Karnety z określoną liczbą wejść',
    [BenefitType.FIXED_COST]: 'Usługi z określoną ceną'
};
export const DisplayBenefitTypeTranslation = {
    [DisplayBenefitType.AMOUNT_DISCOUNT]: 'Zniżka kwotowa',
    [DisplayBenefitType.PERCENT_DISCOUNT]: 'Zniżka procentowa',
    [DisplayBenefitType.TIME]: 'Karnety czasowe',
    [DisplayBenefitType.USAGES]: 'Karnety z określoną liczbą wejść',
    [DisplayBenefitType.FIXED_COST]: 'Usługi z określoną ceną'
};
/**
 * @deprecated
 */
export const BenefitIconTypeTranslation = {
    [BenefitType.AMOUNT_DISCOUNT]: 'mdi-cash',
    [BenefitType.PERCENT_DISCOUNT]: 'mdi-arrow-down-bold',
    [BenefitType.TIME]: 'mdi-timer',
    [BenefitType.USAGES]: 'mdi-ticket',
    [BenefitType.FIXED_COST]: 'mdi-cash'
};
export const DisplayBenefitIconTypeTranslation = {
    [DisplayBenefitType.AMOUNT_DISCOUNT]: 'mdi-cash',
    [DisplayBenefitType.PERCENT_DISCOUNT]: 'mdi-arrow-down-bold',
    [DisplayBenefitType.TIME]: 'mdi-timer',
    [DisplayBenefitType.USAGES]: 'mdi-ticket',
    [DisplayBenefitType.FIXED_COST]: 'mdi-cash'
};
export const DisplayBenefitValue = {
    [DisplayBenefitType.AMOUNT_DISCOUNT]: 'zł',
    [DisplayBenefitType.PERCENT_DISCOUNT]: '%',
    [DisplayBenefitType.TIME]: 'min',
    [DisplayBenefitType.USAGES]: '',
    [DisplayBenefitType.FIXED_COST]: 'zł'
};
//# sourceMappingURL=benefitType.enum.js.map